var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"cl":""}},[_c('div',{ref:"div",class:{ 'ys-float-btn user-btn': true, 'slot-btn': !_vm.imgSrc && !_vm.text },style:({
      left: _vm.left + 'px',
      top: _vm.top + 'px',
      'z-index': _vm.zIndex,
      width: !_vm.imgSrc && !_vm.text ? 'auto' : _vm.itemWidth + 'px',
      height: !_vm.imgSrc && !_vm.text ? 'auto' : _vm.itemHeight + 'px'
    }),attrs:{"id":_vm.box},on:{"click":_vm.onClick}},[_vm._t("default"),(_vm.imgSrc)?_c('img',{class:[_vm.text ? 'img-multiple' : 'img-only'],attrs:{"src":_vm.imgSrc,"alt":""}}):_vm._e(),(_vm.text)?_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.text))]):_vm._e()],2)])}
var staticRenderFns = []

export { render, staticRenderFns }